export const Environement = Object.freeze({
  BASE_API_URL: 'https://api.escalnet.escalconsulting.com',
  BASE_API_URL_LIVE: 'http://localhost',
  SERVER_PRESSROOM: 'https://pressroom.escalconsulting.com',
  SERVER_TEST_PRESSROOM: 'https://test.pressroom.escalconsulting.com',
  DOCUMENTS_URL: 'https://documents.escalconsulting.com',
  PARUTIONS_URL: 'https://parutions.escalconsulting.com'
});
